'use client'
import { gtmFromRedirectedToCompany } from '@/app/[lng]/components/GTMTrackers/GTMCompanyTracker'
import { NewsItem } from '@/app/types/newsType'
import { companyProfileRedirection } from '@/lib/redirectionUtils'
import Link from 'next/link'

const NewsCompanyRedirection = ({
  newsDetails,
  lng,
}: {
  newsDetails: NewsItem
  lng: string
}) => {
  return (
    <div className="flex flex-row mobile:justify-start gap-2 px-0 py-2 text-sm font-ns_bold">
      <p className="">
        {newsDetails?.signature && `${newsDetails?.signature}`}{' '}
        {newsDetails?.signature && newsDetails?.company?.name && '| '}
        {newsDetails?.company?.name && (
          <Link
            href={companyProfileRedirection(
              newsDetails?.company?.sector ?? '',
              newsDetails?.company?.friendly_url ?? '',
              lng
            )}
            className="font-ns_bold text-primary underline"
            onClick={() => {
              gtmFromRedirectedToCompany(
                'news_detail',
                newsDetails?.company?.friendly_url ?? '',
                String(newsDetails?.company?.id)
              )
            }}
          >
            {newsDetails?.company?.name}
          </Link>
        )}
      </p>
    </div>
  )
}

export default NewsCompanyRedirection
